import { defineStore } from 'pinia'

export type AuthModalType = 'login' | 'register' | 'forgotPassword' | null

export const useAuthModalStore = defineStore('authModal', {
  state: () => ({
    currentModal: null as AuthModalType,
    isOpen: false,
    alertMessage: null as string | null
  }),

  getters: {
    isLoginModalOpen: (state) => state.currentModal === 'login' && state.isOpen,
    isRegisterModalOpen: (state) => state.currentModal === 'register' && state.isOpen,
    isForgotPasswordModalOpen: (state) => state.currentModal === 'forgotPassword' && state.isOpen,
    hasOpenModal: (state) => state.isOpen && state.currentModal !== null
  },

  actions: {
    openLoginModal() {
      this.currentModal = 'login'
      this.isOpen = true
    },

    openRegisterModal() {
      this.currentModal = 'register'
      this.isOpen = true
    },

    openForgotPasswordModal() {
      this.currentModal = 'forgotPassword'
      this.isOpen = true
    },

    switchToRegister() {
      this.currentModal = 'register'
    },

    switchToLogin() {
      this.currentModal = 'login'
    },

    switchToForgotPassword() {
      this.currentModal = 'forgotPassword'
    },

    closeModal() {
      this.isOpen = false
      this.currentModal = null
      this.alertMessage = null
    },

    closeAllModals() {
      this.closeModal()
    },

    setAlertMessage(message: string) {
      this.alertMessage = message
    },

    clearAlertMessage() {
      this.alertMessage = null
    },

    openLoginModalWithAlert(message: string) {
      this.setAlertMessage(message)
      this.openLoginModal()
    }
  }
})
